export default "__VITE_ASSET__CDSSiK_P__"